<script setup>
import { ref, computed, onMounted } from "vue";

import budgetsModal from "@/components/modal/budgets-modal.vue";
import { useBudgetExpenseStore } from "@/stores/budgetExpenseStore";

const title = ref("Budgets Expenses");
const text = ref("HR");
const text1 = ref("Budgets Expenses");

const expenseStore = useBudgetExpenseStore();

// expose main budget modal so we can open it from here
const budgetModalRef = ref(null);

const columns = [
  { sorter: false },
  {
    title: "Expense Name",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Category Name",
    dataIndex: "category_name",
    key: "category_name",
  },
  {
    title: "Sub Category Name",
    dataIndex: "sub_category_name",
    key: "sub_category_name",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Budget",
    dataIndex: "budget_title",
    key: "budget_title",
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

const pagination = computed(() => ({
  total: expenseStore.meta.total,
  current: expenseStore.meta.current_page,
  pageSize: expenseStore.meta.per_page,
  showSizeChanger: false,
}));

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function handleTableChange(pager) {
  expenseStore.fetch({ page: pager.current });
}

/* Filters */
function onSearch() {
  expenseStore.fetch({ page: 1 });
}

/* Add expense actually means: open main Budget modal in create mode */
function openAddExpense() {
  budgetModalRef.value?.openCreate();
}

/* Edit: open its parent budget in edit mode */
function openEdit(record) {
  if (!record?.budget_id) return;
  budgetModalRef.value?.openEdit({ id: record.budget_id });
}

/* Delete actual line item */
async function deleteExpense(record) {
  if (!record?.id) return;
  if (!window.confirm("Delete this expense item?")) return;
  await expenseStore.remove(record.id);
}

onMounted(() => {
  expenseStore.fetch();
});
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <!-- <div class="mb-2">
            <button
              type="button"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddExpense"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Expense
            </button>
          </div> -->
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Budgets Expenses list -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Budget Expenses List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-2">
              <input
                type="text"
                class="form-control"
                placeholder="Search expense..."
                v-model="expenseStore.filters.q"
                @keyup.enter="onSearch"
              />
            </div>
            <button class="btn btn-sm btn-white" @click="onSearch">
              <i class="ti ti-search me-1"></i>Search
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="expenseStore.items"
              :row-selection="rowSelection"
              :loading="expenseStore.loading"
              :pagination="pagination"
              @change="handleTableChange"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'title'">
                  <h6 class="fw-medium mb-0">
                    <a href="javascript:void(0);">{{ record.title }}</a>
                  </h6>
                  <small class="text-muted" v-if="record.budget_title">
                    Budget: {{ record.budget_title }}
                  </small>
                </template>

                <template v-else-if="column.key === 'amount'">
                  {{
                    Number(record.amount || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </template>

                <!-- <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      @click.prevent="openEdit(record)"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      @click.prevent="deleteExpense(record)"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template> -->
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Budgets Expenses list -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <!-- Reuse the main budget modal -->
  <budgets-modal ref="budgetModalRef" />
</template>


